/*-----------------------------------------------------------------
- Ware Detail
-----------------------------------------------------------------*/
export default {
    categories  : 'دسته‌بندی',
    separator   : '،',
    price       : 'قیمت مصرف کننده',
    choose_wares: 'انتخاب نوع بسته‌بندی',
    percent_mark: '٪',
    add_to_cart : 'افزودن به سبد خرید',
    empty       : {
        description:
            'متاسفانه این کالا در حال حاضر موجود نیست. میتوانید از طریق لیست زیر، از محصولات مشابه این کالا دیدن کنید',
        button: 'موجود شد به من خبر بده',
        title : 'ناموجود',
    },
    number    : 'عدد',
    rate_count: '{count} نظر',
    wishlist  : {
        add_msg   : 'محصول با موفقیت به لیست علاقه‌مندی‌ها اضافه شد.',
        delete_msg: 'محصول با موفقیت از لیست علاقه‌مندی‌ها حذف شد.',
    },
    login: 'برای افزودن به علاقه‌مندی‌ها، ابتدا وارد شوید.',
};
